var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pt-4"},[_c('router-link',{staticClass:"bg-gray-700 rounded p-6 text-white font-bold text-2xl max-w-xs m-auto text-center mt-20 block",attrs:{"to":"step1"}},[_vm._v("Get Started")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }